import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { SoilUseService } from '../proxy/planning/controllers/soil-use.service';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { PropertyService } from '@planning/proxy/planning/controllers';
import { PropertyTypeService } from '../proxy/planning/controllers/property-type.service';
import { OtherUsePerRegister } from '../other-use-per-register/other-use-per-register';

FieldBuilder.setNamespace('Planning');

export const OTHERUSE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.OtherUse.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .number('otherUsearea', 'Entity.OtherUse.OtherUsearea')
    .required()
    .decimal(2,10)
    .build(),
  FieldBuilder
    .foreignKey('propertyId', 'Entity.Property', PropertyService)
    .required()
    .displayFromNested('property.name')
    .sortBy('property.name')
    .build(),
  FieldBuilder
    .foreignKey('propertyTypeId', 'Entity.PropertyType', PropertyTypeService)
    .required()
    .displayFromNested('propertyType.name')
    .sortBy('propertyType.name')
    .build(),
  FieldBuilder
    .foreignKey('soilUseId', 'Entity.SoilUse', SoilUseService)
    .required()
    .displayFromNested('soilUse.name')
    .sortBy('soilUse.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const OTHERUSE_CONFIG = {
  entityName: 'OtherUse',
  localizationKey: 'Planning::Entity.OtherUse',
  permission: 'PlanningLocation.OtherUses',
  fields: OTHERUSE_FIELDS,
  children: [
    {
      entityName: 'OtherUsePerRegister',
      foreignKeyField: 'otherUseId',
      localizationKey: 'Planning::Entity.OtherUsePerRegister',
      component: OtherUsePerRegister,
    },
  ],
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
